import { Http } from "@/plugins/http";

export class MedicineService {
  /**
   * Возвращает список статусов
   * @return Promise<*>
   */
  static getStatuses() {
    return Http.get(`v1/medicines/statuses`, {
      params: {
        lang: "ru",
      },
    }).then(response => response.data.data);
  }
}
